import Sortable from 'sortablejs/Sortable';
export default class CategoryController {
  constructor(ImagesDataProvider, $state, APPLICATION_URL) {
    "ngInject"
    this.ImagesDataProvider = ImagesDataProvider;
    this.$state = $state;
    this.currentPage = 1;
    this.pageLimit = '100';
    this.maxSize = 5;
    this.pageLimitOptions = {10: 10, 20: 20, 50: 50, 100: 100, 9999: 'All'};
    this.type = 1;
    this.field = 'image_id';
    this.order_type = 'desc';
    this.col = 0;
    this.colTopDown = 0;
    this.APPLICATION_URL = APPLICATION_URL;
    this.parentId = $state.params.parentId;
    if (this.parentId) {
      this.pageLimit = '9999';
      this.field = 'order_by';
      this.order_type = 'asc';
      let
        el = document.getElementById('items');
      let
        vm = this;
      vm.sortingLog = [];
      let
        sortable = Sortable.create(el, {
          onStart: function (evt) {
            evt.oldIndex;
            console.log('start');
          },
          onEnd: function (evt) {
            let
              oldData = angular.copy(vm.categories);
            let
              i = 0;
            if (evt.oldIndex < evt.newIndex) {
              for (i = evt.oldIndex; i <= evt.newIndex; i++) {
                if (i == evt.newIndex) {
                  vm.categories[i] = oldData[evt.oldIndex];
                }
                else {
                  vm.categories[i] = oldData[i + 1];
                }
              }
            }
            if (evt.oldIndex > evt.newIndex) {
              for (i = evt.oldIndex; i >= evt.newIndex; i--) {
                if (i == evt.newIndex) {
                  vm.categories[i] = oldData[evt.oldIndex];
                }
                else {
                  vm.categories[i] = oldData[i - 1];
                }
              }
            }
            vm.categories.map(function (i) {
              vm.sortingLog.push(i.image_id);
            });
            ImagesDataProvider.updateImageOrder(vm.sortingLog).then(function (result) {
              vm.getImages();
            });
            vm.sortingLog = [];
          }
        });
    }
    else {
      this.parentId = 0;
    }
    this.getImages();
  }

  getSortRecors(field, order_type, col, colTopDown) {
    this.field = field;
    this.order_type = order_type;
    this.col = col;
    this.colTopDown = colTopDown;
    this.getImages();
  }

  getImages() {
    let
      vm = this;
    let data = [];
    data.currentPage = vm.currentPage;
    data.pageLimit = vm.pageLimit;
    data.field = vm.field;
    data.order_type = vm.order_type;
    data.image_category_id = vm.parentId;
    vm.ImagesDataProvider.getImages(data).then(function (result) {
      vm.categories = result.data;
      vm.categoriesTotal = result.total;
    });
  }

  removeRecord(id) {
    if (confirm("Are you sure to delete!") !== true) {
      return false;
    }
    let vm = this;
    vm.ImagesDataProvider.removeImage(id).then(function (res) {
      vm.getImages();
    })
  }
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/images/components/list/controller.js
 **/